/** Mongo hands times back without a zone suffix; they are UTC. */
export const asUtc = (iso: string) => (/(Z|[+-]\d\d:\d\d)$/.test(iso) ? iso : `${iso}Z`);

/** A stored UTC time as an Indian date and time, or "—". */
export const formatIst = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  try {
    return new Date(asUtc(iso)).toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return iso;
  }
};
